export const IS_V53_ENABLED_ENV = process.env.NEXT_PUBLIC_ENABLE_V53 === 'true';
